import React, { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Modal, Button } from 'react-bootstrap';
import OTPInput from "otp-input-react";

import RoundCloseButton from "../../images/round-close-button.png";
import ArrowBack from "../../images/black-mii-left.png";
import OTPMailBox from "../../images/otp-mailbox.png";
import OTPSuccess from "../../images/otp-success.png";
import TooManyInput from "../../images/too-many-input.png";
import ChangedPassword from "../../images/changed-password.png";
import BankAccountAlert from "../../images/bank-account-alert.png";
import Countdown from 'react-countdown-now';

/**
 * Custom Hooks
 */
 import { useOtpStorage } from "../../helpers/dom"

interface ModalOtpProps {
  show: boolean;
  gettingOtp: boolean;
  email: string;
  currentProcess: string;
  errorMsg: string;
  onHide: () => void;
  resendCode: () => void;
  backAction: () => void;
  submitOtp: (args: string) => void;
}

const rendered = ({ seconds, completed, minutes, resendCode }) => {
  if (completed) {
    return (<p onClick={() => resendCode()} className='resend'>Resend</p>);
  } else {
    return (<p className='resend-code'>Resend OTP in {seconds}s</p>);
  }
}

/**
 * @param {ModalOtpProps} props for this component.
 * @return {JSX.Element}
 */
function ModalOtp({
  submitOtp,
  backAction,
  resendCode,
  email,
  show,
  gettingOtp,
  errorMsg,
  onHide,
  currentProcess,
}: ModalOtpProps) {
  const { checkIfExpired, getFromLocalStorage, getResendOtpTime, checkIfRsendOtpExpired } = useOtpStorage()

  const [OTP, setOTP] = useState("");
  const [process, setProcess] = useState(errorMsg === "You already exceeded maximum limit to request OTP!" ? "maximum-limit" : "enter-otp");
  const [image, setImage] = useState<any>(null);
  const [disableInput, setDisableInput] = useState(false);
  const [seconds, setSeconds] = useState(0)

  const [title, setTitle] = useState("")
  const [text, setText] = useState<any>(null)
  const [buttonText, setButtonText] = useState("")
  const [_className, set_ClassName] = useState("")

  const setDinamicResult = (_process) => {
    switch (_process) {
      case "password-changed": {
        setImage(ChangedPassword)
        setTitle("Password Changed")
        setText(
          <p className='text result-text'>Your password has been changed successfully.</p>
        )
        setButtonText("OK")
        break;
      }
      case "bank-account-success": {
        setImage(OTPSuccess)
        setTitle("Bank Account Changed")
        setText(
          <p className='text result-text'>Your bank account information has been changed.</p>
        )
        setButtonText("OK")
        break;
      }
      // case "maximum-limit": {
      //   setImage(TooManyInput)
      //   break;
      // }
      case "maximum-limit": {
        setImage(BankAccountAlert)
        setTitle("Hold On")
        setText(
          <p className='text result-text'>You have attempted too many time, <span style={{ display: "block" }} /> please wait 2 hours</p>
        )
        setButtonText("OK")
        set_ClassName("maximum-limit")
        break;
      }
      default:
        set_ClassName("")
        break;
    }
  }

  const dynamicAction = (_process) => {
    switch (_process) {
      case "password-changed": {
        onHide()
        break;
      }
      case "bank-account-success": {
        onHide()
        break;
      }
      case "maximum-limit": {
        onHide()
        break;
      }
      default:
        break;
    }
  }

  const RenderErrorMessage = (errorMsg): string => {
    switch (errorMsg) {
      case "Invalid OTP": {
        return "Verification code is incorrect"
      }
      default: {
        return errorMsg
      }
    }
  }

  useEffect(() => {
    setDinamicResult(process)
  }, [process])

  useEffect(() => {
    if (OTP?.length === 6) {
      setDisableInput(true)
      submitOtp(OTP)
    }
  }, [OTP])

  useEffect(() => {
    if (!gettingOtp) {
      setDisableInput(false)
      const otpExpiryDate = getResendOtpTime()

      if (otpExpiryDate) {
        const currentDate = Date.now();

        if (otpExpiryDate > currentDate) {
          setSeconds(otpExpiryDate)
        } else {
          setSeconds(0)
        }
      }
    } else {
      setDisableInput(true)
    }
  }, [gettingOtp])

  useEffect(() => {
    if (errorMsg === "You already exceeded maximum limit to request OTP!") {
      setProcess("maximum-limit")
    }
  }, [errorMsg])

  useEffect(() => {
    if (currentProcess) {
      setProcess(currentProcess)
    }
  }, [currentProcess])

  return (
    <Modal
      show={show}
      onHide={() => onHide()}
      id="modal-otp"
      centered
    >
      {
        process === "enter-otp" ?
          (
            <Modal.Body>
              <KickImage onClick={() => onHide()} className='close-btn' src={RoundCloseButton} alt='close-btn' />
              <div onClick={() => backAction()} className='back-icon-contianer'>
                <KickImage className='back-icon' src={ArrowBack} alt='back' />
              </div>
              <KickImage className='mail-icon' src={OTPMailBox} alt='mail-icon' />
              <p className='title'>Enter the OTP</p>
              <p className='text'>Please check a verification email sent to <span className='email'>{email}’s <span className='inbox'>inbox.</span></span> </p>
              <div className='otp-input-wrapper'>
                <OTPInput className={`otp-input ${errorMsg ? "error" : ""}`} value={OTP} onChange={setOTP} autoFocus OTPLength={6} otpType="number" disabled={disableInput || gettingOtp} />
              </div>
              {errorMsg ? <p className='error-text'>{RenderErrorMessage(errorMsg)}</p> : null}
              <Countdown
                date={seconds}
                renderer={rendered}
                resendCode={() => {
                  if(checkIfRsendOtpExpired()){
                    resendCode()
                  }
                }}
                onComplete={() => {
                  setOTP("")
                }}
              />
              {false && <Modal.Body className="loading-wrapper">
                <KickImage src={OTPSuccess} alt="..." />
              </Modal.Body>}
            </Modal.Body>
          ) : (
            <Modal.Body className='result-modal-body'>
              <KickImage onClick={() => onHide()} className='close-btn' src={RoundCloseButton} alt='mail-icon' />
              {image ? <KickImage className={`mail-icon result ${_className}`} src={image} alt='close-btn' /> : null}
              <p className='title'>{title}</p>
              {text ? text : null}
              <Button onClick={() => {
                dynamicAction(process)
              }} className='button'>
                {buttonText}
              </Button>
            </Modal.Body>
          )
      }
    </Modal>
  );
}

export default ModalOtp;
